import _ from 'underscore';
import { Storage as WebStorage } from '@app/interfaces';

class LocalStorage implements WebStorage {
	constructor(private readonly ls: Storage) {}

	get<T>(key: string): T {
		let value: T = null;
		try {
			const storedValue = this.ls.getItem(key);
			if (storedValue) {
				value = JSON.parse(storedValue);
			}
		} catch {
			// do nothing
		}
		return value;
	}

	set(key: string, value: any): void {
		const stringified = JSON.stringify(value);
		this.ls.setItem(key, stringified);
	}

	clear(): void {
		this.ls.clear();
	}

	/**
	 * Removes a key or property within a key
	 *
	 * @example
	 * remove('base-settings') // removes key from localstorage
	 * remove('base-settings.position') // removes position property from base-settings key
	 * remove(['base-settings', 'position']) // removes position property from base-settings key
	 * remove(['base-settings'])
	 */
	remove(key: string | string[]): void {
		if (Array.isArray(key)) {
			this.removeByPath(key);
			return;
		}

		const path = key.split('.');
		const isByPath = path.length > 1;
		if (isByPath) {
			this.removeByPath(path);
			return;
		}

		this.ls.removeItem(key);
	}

	private removeByPath(path: string[]) {
		if (path.length <= 1) {
			this.remove(path[0]);
			return;
		}
		const [key, ...property] = path;
		const value = this.get(key);
		const omittedValue = _.omit(value, property);
		this.set(key, omittedValue);
	}
}

export const localStorage = new LocalStorage(window.localStorage);
